import icon from "@material-ui/icons/Copyright"

export default { icon } ;